/** @format */

import React, { useEffect, useState, useRef } from "react";
import { observer } from "mobx-react-lite";
//styles:
import "./OpenInAppStyle.scss";
import "../../styles/fonts.scss";
import { isAndroid, isIOS } from "react-device-detect";

const ResetSucceeded = (props) => {
  useEffect(() => {
// --> for the app
if (isAndroid) {
  // intent:  
  // HOST/URI-path // Optional Host  
  // #Intent;  
  //   package=\[string\];  
  //   action=\[string\];  
  //   category=\[string\];  
  //   component=\[string\];  
  //   scheme=\[string\];  
  // end;

  const url =
    `intent://exp.host:443/hilma/play-smart/?data=enter-new-password&${window.location.search.slice(1)}#Intent;scheme=https;package=com.hilma.playSmart;component=enter-new-password&${window.location.search.slice(1)};end`;
  window.location.replace(url);
} else if (isIOS) {
  window.location.replace("play-smart://");

  setTimeout(() => {
    window.location.replace(
      `https://playSmart.hilma.com/il/app/PlaySmart/id1596719664?data=enter-new-password&${window.location.search.slice(1)}`
    );
  }, 10000);
}

// --> for the expo:
    // window.location = `exp://192.168.0.174:19000/--/?data=enter-new-password&${window.location.search.slice(1)}`;
  }, []);
  return (
    <div className="full">
      {/* <div className="bla"> */}
      <div className="bla">
        <img
          alt="logo"
          title="logo"
          src="/icons/whiteLogo.svg"
          className="logo"
        />
        <div className="text">
          פתח את הקישור שקיבלת דרך מכשירך על מנת להגדיר סיסמא חדשה
        </div>
      </div>
      <div className="dots-container">
        <img
          alt="circlesBackground"
          title="circlesBackground"
          src="/icons/circlesBackground.svg"
          className="circlesBackground"
        />
      </div>
      {/* </div> */}
    </div>
  );
};

export default observer(ResetSucceeded);



// WEBPACK FOOTER //
// ./src/pages/mailSentComp/ResetSucceeded.jsx